function Chinese() {
    return(
        <div>
        <h1>Chinese Category</h1>
        <img
      src={require("../../assets/images/chickenrice.jpg")}
      alt="chickenrice"
    /> <br/>
    <img
      src={require("../../assets/images/kwaytiao.jpg")}
      alt="kwaytiao"
    />
        </div>
    )

}
export default Chinese;